export default [
    {
        "name": "最优价格",
        "sort": 0,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "最优价格"
    },
    {
        "name": "商务协议散客",
        "sort": 1,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "商务协议散客"
    },
    {
        "name": "政府协议散客",
        "sort": 2,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "政府协议散客"
    },
    {
        "name": "套餐",
        "sort": 3,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "套餐"
    },
    {
        "name": "旅行社",
        "sort": 4,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "旅行社"
    },
    {
        "name": "电子商务",
        "sort": 5,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "电子商务"
    },
    {
        "name": "折扣价",
        "sort": 6,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "折扣价"
    },
    {
        "name": "散客总计",
        "sort": 7,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "散客总计"
    },
    {
        "name": "公司团",
        "sort": 8,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "公司团"
    },
    {
        "name": "旅行团",
        "sort": 9,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "旅行团"
    },
    {
        "name": "团队总计",
        "sort": 10,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "团队总计"
    },
    {
        "name": "合同",
        "sort": 11,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "合同"
    },
    {
        "name": "其他",
        "sort": 12,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "其他"
    },
    {
        "name": "其他总计",
        "sort": 13,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "其他总计"
    },
    {
        "name": "总计",
        "sort": 14,
        "dayRn": 0,
        "dayAbr": 0,
        "dayAdr": 0,
        "dayRev": 0,
        "dayRevAbr": 0,
        "monthRn": 0,
        "monthAbr": 0,
        "monthAdr": 0,
        "monthRev": 0,
        "monthRevAbr": 0,
        "budgetRn": 0,
        "budgetAbr": 0,
        "budgetAdr": 0,
        "budgetRev": 0,
        "budgetRevAbr": 0,
        "varRn": 0,
        "varAdr": 0,
        "varRev": 0,
        "forecastRn": 0,
        "forecastAbr": 0,
        "forecastAdr": 0,
        "forecastRev": 0,
        "forecastRevAbr": 0,
        "varForecastRn": 0,
        "varForecastAdr": 0,
        "varForecastRev": 0,
        "lastRn": 0,
        "lastAbr": 0,
        "lastAdr": 0,
        "lastRev": 0,
        "lastRevAbr": 0,
        "varLastRn": 0,
        "varLastAdr": 0,
        "varLastRev": 0,
        "code": "总计"
    }
]


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.2/data.js